export default __webpack_public_path__ + "static/media/Leaders_IMG-YMRaja-02.32c1543d.png";